import React from "react";

const LazyMeeting = React.lazy(() => import("./Meeting").then((module) => ({ default: module.Meeting })));

export default LazyMeeting;
